/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS16 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_15;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_16;
    },
    getDownloadName() {
      return ns.IOS16.nice_name;
    },
  });

  Object.assign(IOS16, {
    slug: `ios_16`,
    nice_name: `iOS 16 adoption`,
    description: `How quickly are consumers upgrading to iOS 16?`,
  });
  ns.IOS16 = IOS16;
});

}.call(window));